import React, { useState, useEffect } from "react";
import Logo from "../images/inkhouse-logo.png";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

function Nav() {
  const [scrollDirection, setScrollDirection] = useState("up");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setScrollDirection("down");
      } else {
        setScrollDirection("up");
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 bg-[#2a2a2a] shadow-md transition-transform duration-300 ${
        scrollDirection === "down" ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="flex justify-between items-center px-4 py-2 sm:p-7 md:pl-[5rem] sm:py-2 md:py-2">
        <div className="flex items-center">
          <Link to={"/"}>
            <img className="w-[8rem] md:w-[12rem]" src={Logo} alt="Logo" />
          </Link>
        </div>
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="text-white focus:outline-none mt-4"
          >
            {menuOpen ? <X size={30} /> : <Menu size={30} />}
          </button>
        </div>
        <div
          className={`md:flex ${
            menuOpen ? "block" : "hidden"
          } absolute top-[4rem] left-0 w-full bg-[#2a2a2a] md:static md:w-auto md:bg-transparent pt-[2rem] pb-[2rem]`}
        >
          <div className="flex flex-col md:flex-row md:justify-between md:items-center">
            <Link
              to={"/about"}
              className="text-white py-2 px-4 md:py-0 lg:mx-10 xl:mx-16 duration-100 hover:border-b-2 hover:border-white"
              onClick={closeMenu}
            >
              about
            </Link>
            <Link
              to={"/team"}
              className="text-white py-2 px-4 md:py-0 lg:mx-10 xl:mx-16 duration-100 hover:border-b-2 hover:border-white"
              onClick={closeMenu}
            >
              team
            </Link>
            <Link
              to={"/gallery"}
              className="text-white py-2 px-4 md:py-0 lg:mx-10 xl:mx-16 duration-100 hover:border-b-2 hover:border-white"
              onClick={closeMenu}
            >
              gallery
            </Link> 
            <Link
              to={"/aftercare"}
              className="text-white py-2 px-4 md:py-0 lg:mx-10 xl:mx-16 duration-100 hover:border-b-2 hover:border-white"
              onClick={closeMenu}
            >
              aftercare
            </Link>
            <Link
              to={"/contact"}
              className="text-white py-2 px-4 md:py-0 lg:mx-10 xl:mx-16 duration-100 hover:border-b-2 hover:border-white"
              onClick={closeMenu}
            >
              contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
